export default __webpack_public_path__ + "static/media/imgActivity8-6.cf2cdff4.png";